var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from './api-model';
var Privilege = /** @class */ (function (_super) {
    __extends(Privilege, _super);
    function Privilege() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Privilege.prototype.checkedByProfiles = function (profiles) {
        var _this = this;
        this.checked = false;
        this.checkedByExtends = false;
        profiles.forEach(function (profile) {
            if (profile.hasPrivilege(_this)) {
                _this.checked = true;
                _this.checkedByExtends = true;
                _this.checkedByLogic = false;
            }
        });
        return this;
    };
    Privilege.prototype.checkedByInputPrivileges = function (privileges) {
        var _this = this;
        if (!!privileges.find(function (privilege) { return privilege.action === _this.action && privilege.component === _this.component; })) {
            this.checked = true;
            // this.checkedByExtends = false;
        }
        return this;
    };
    Privilege.prototype.checkedByLogicPrivileges = function (privileges, privilegesState) {
        var _this = this;
        this.checkedByLogic = false;
        if (this.action === 1) {
            if (privilegesState.find(function (p) { return p.checked && p.action === 2 && p.component === _this.component; })) {
                this.checked = true;
                this.checkedByLogic = true;
            }
        }
    };
    return Privilege;
}(ApiModel));
export { Privilege };



// WEBPACK FOOTER //
// ./src/app/models/privilege.ts.pre-build-optimizer.js